import { render, staticRenderFns } from "./ResponderList.vue?vue&type=template&id=1d6228fa&scoped=true&"
import script from "./ResponderList.vue?vue&type=script&lang=js&"
export * from "./ResponderList.vue?vue&type=script&lang=js&"
import style0 from "./ResponderList.vue?vue&type=style&index=0&id=1d6228fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6228fa",
  null
  
)

export default component.exports